import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import { toast } from "sonner";
import { web, errMsg } from "../../lib/api";
import { useInviteWebsite, refreshInviteWebsite, siteLabel } from "../../hooks/useInviteWebsite";
import { Panel, Btn } from "./kit";
import { TextInput } from "./Form";

/** Admin setting: the website address added to every team and free-access invite. */
export const InviteWebsite = () => {
  const current = useInviteWebsite();
  const [saved, setSaved] = useState(null);
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);
  const shown = saved ?? current;
  useEffect(() => { setVal(siteLabel(shown)); }, [shown]);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await web.put("/admin/invite-website", { url: val });
      refreshInviteWebsite();
      setSaved(data.url);
      toast.success(`Invites now link to ${siteLabel(data.url)}`);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Panel className="mb-8" data-testid="invite-website-panel">
      <h3 className="flex items-center gap-2 font-display text-xl font-bold uppercase text-white"><Globe className="h-5 w-5 text-[#39FF14]" />Website in invites</h3>
      <p className="mt-1 text-sm text-slate-400">Added to every team invite message, the invite page and free-access emails. Now: <a data-testid="invite-website-current" href={shown} target="_blank" rel="noreferrer" className="text-white underline decoration-[#39FF14]/60">{siteLabel(shown)}</a></p>
      <form onSubmit={save} className="mt-4 flex flex-col gap-2 sm:flex-row">
        <TextInput data-testid="invite-website-input" value={val} maxLength={200} onChange={(e) => setVal(e.target.value)} placeholder="hoopshq.net" className="sm:max-w-sm" />
        <Btn type="submit" data-testid="invite-website-save" disabled={busy || !val.trim()}>{busy ? "Saving…" : "Save"}</Btn>
      </form>
    </Panel>
  );
};
